class NewSignupForm extends HTMLElement {
  constructor() {
    super();
    this.submittedEmails = new Set();
    this.checkebox();
    this.initForm();
  }

  initForm() {
    const sectionid = this.dataset.sectionid;
    let formID ="js-oasis-count-down-"+ sectionid;
    const popupForm = document.getElementById(formID);
    const listid = this?.dataset.listId;
    const errorMessage = popupForm?.dataset.errorMessage || "Something went wrong.";
    const submitButton = this.querySelector('.submit-btn');
    const termsAndConditionsCheckbox = this.querySelector('.sign-form__checkbox');

    if (!popupForm) return;

    popupForm.addEventListener("submit", (event) => {
      event.preventDefault();
      const formData = new FormData(event.target);
      const email = formData.get('contact[email]');
      const name = formData.get('contact[name]');

      if (!this.validateEmail(email)) {
        this.querySelector('.Alert--error').style.display = 'block';
        this.querySelector('.Alert--success').style.display = 'none';
        submitButton.style.display = 'none';
        termsAndConditionsCheckbox.style.display = 'none';
        console.log("Invalid email");
        return;
      }

      if (this.submittedEmails.has(email)) {
        this.querySelector('.Alert--error').textContent = 'This email has already been submitted.';
        this.querySelector('.Alert--error').style.display = 'block';
        this.querySelector('.Alert--success').style.display = 'none';
        submitButton.style.display = 'none';
        termsAndConditionsCheckbox.style.display = 'none';
        return;
      }

      const requestBody = {
        method: 'POST',
        headers: {
          revision: '2025-04-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Homepage footer signup form',
              profile: {
                data: {
                  type: 'profile',
                  id: '01GDDKASAP8TKDDA2GRZDSVP4H',
                  attributes: {
                    email,
                    first_name: name
                  }
                }
              }
            },
            relationships: {
              list: {
                data: { type: 'list', id: listid }
              }
            }
          }
        })
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=WPfH8e', requestBody)
      .then(response => {
          if (response.ok) {
            this.querySelector('.Alert--success').style.display = 'block';
            this.querySelector('.Alert--error').style.display = 'none';
            submitButton.style.display = 'none';
            termsAndConditionsCheckbox.style.display = 'none';
            this.submittedEmails.add(email);
          } else {
            this.querySelector('.Alert--error').textContent = errorMessage;
            this.querySelector('.Alert--error').style.display = 'block';
            this.querySelector('.Alert--success').style.display = 'none';
            submitButton.style.display = 'none';
            termsAndConditionsCheckbox.style.display = 'none';
          }
        })
        .catch(error => {
          this.querySelector('.Alert--error').textContent = errorMessage;
          this.querySelector('.Alert--error').style.display = 'block';
          this.querySelector('.Alert--success').style.display = 'none';
          submitButton.style.display = 'none';
          termsAndConditionsCheckbox.style.display = 'none';
          console.error("Submission error", error);
        });
    });

    popupForm.addEventListener('input', () => {
      submitButton.style.display = 'flex';
      termsAndConditionsCheckbox.style.display = 'flex';
      this.querySelector('.Alert--error').style.display = 'none';
      this.querySelector('.Alert--success').style.display = 'none';
    });
  }

  checkebox(){
      const submitButton = this.querySelector('.submit-btn');
        const checkbox = this.querySelector('input[type="checkbox"]');
      const labels = this.querySelectorAll('.checkbox_wrapper');
      const icon_svg = this.querySelectorAll('svg')
      submitButton.addEventListener("click", (event) => {
      if (!checkbox.checked) {
        icon_svg.forEach((icon) => {
          icon.style.stroke = 'rgb(208, 51, 31)';
          icon.style.fill = 'rgb(208, 51, 31)';
        });
      } else {
         icon_svg.forEach((icon) => {
         icon.style.stroke = 'rgb(72, 41, 34)';
          icon.style.fill = 'rgb(72, 41, 34)';
        });
      }
    });
     checkbox.addEventListener("change", () => {
      labels.forEach(label => {
        const svg = label.querySelector(".squre_svg");
        if (svg) svg.style.stroke = checkbox.checked ? 'rgb(72, 41, 34)' : 'rgb(208, 51, 31)';
      });
    });
  }
  validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }
}

customElements.define("new-signup-form", NewSignupForm);
